import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const charger = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/moi");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { charger(); }, [charger]);

  const connexion = async (email, mot_de_passe) => {
    const { data } = await api.post("/auth/connexion", { email, mot_de_passe });
    setUser(data);
    return data;
  };

  const deconnexion = async () => {
    await api.post("/auth/deconnexion").catch(() => {});
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, connexion, deconnexion, charger }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
